import React from "react";
import { Badge, Icon } from "@chakra-ui/react";
import { getStatusConfig } from "./legalDocumentConstants";

/**
 * Renders a status badge (icon + label) for a legal document status.
 * @param {object} props - Component props
 * @param {string} props.status - Document status key (active/inactive/scheduled/draft)
 * @returns {React.ReactElement}
 */
function LegalStatusBadge({ status, ...rest }) {
    const cfg = getStatusConfig(status);
    return (
        <Badge display="inline-flex" alignItems="center" gap="4px" bg={cfg.bgColor}
            color={cfg.color} border="1px solid" borderColor={`${cfg.color}66`}
            borderRadius="full" px="8px" py="2px" fontSize="0.68rem" fontWeight="600" textTransform="none" {...rest}>
            <Icon as={cfg.Icon} boxSize="12px" />
            {cfg.label}
        </Badge>
    );
}

export default LegalStatusBadge;
